import { inventoryInitialStockApi } from '../../api';
import { InitialStockRegistration } from '../../types/inventory/InitialStockTypes';

const InitialStockService = {
    /**
     * Registra una existencia inicial.
     * POST /api/inventory/initial-stock
     */
    registerInitialStock: async (data: InitialStockRegistration) => {
        const response = await inventoryInitialStockApi.add(data);
        return response.data;
    }
};

export default InitialStockService;
